/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { resetCheckoutFields } from '../store/CheckoutFields/CheckoutFields.action';

const handleLogout = (args, callback) => {
    const dispatch = args?.[2];

    dispatch(resetCheckoutFields());
    callback(...args);
};

export default {
    'Store/MyAccount/Dispatcher': {
        'member-function': {
            logout: handleLogout
        }
    }
};
